import axios from "axios";
import baseUrl from "../config/baseUrl";


export async function performOCR(payload, token) {

  try {
    const formData = new FormData();
    formData.append("file", payload.file);
    formData.append("questions", JSON.stringify(payload.questions));

    const response = await axios.post(`${baseUrl}/ocr/ocrai`, formData, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (err) {
    if (err.response) {
      return {
        error: err.response.data?.error ?? "OCR failed",
        additional_info: err.response.data?.additional_info,
      };
    }
    if (err.request) {
      return {
        error: "Network error",
        additional_info: "Server did not respond",
      };
    }
    return {
      error: "Unexpected error",
      additional_info: err.message,
    };
  }
}
